import { useCallback, useEffect, useState } from "react";
import { type Output } from "valibot";

import merge from "shared/merge";
import { requestBackend } from "shared/request";

import { BotInfoSchema } from "./schemas";
import { BotInfoConfig, UpdateBotInfoConfig } from "./types";
import { defaultBotInfo } from "./constants";

function useBotInfo(token: string) {
  const [botInfo, setBotInfo] =
    useState<Output<typeof BotInfoSchema>>(defaultBotInfo);

  useEffect(() => {
    requestBackend("/v1/botsonic/widget/bot-info", {
      headers: {
        token,
      },
      schema: BotInfoSchema,
    }).then(newBotInfo => {
      const defaultOrResponse = merge(defaultBotInfo, newBotInfo);
      setBotInfo(defaultOrResponse);
    });
  }, [token]);

  const updateBotInfoConfig: UpdateBotInfoConfig = useCallback(
    <T extends keyof BotInfoConfig>(key: T, value: BotInfoConfig[T]) =>
      setBotInfo(prevBotInfo => ({
        ...prevBotInfo,
        bot_info_config: {
          ...prevBotInfo.bot_info_config,
          [key]: value,
        },
      })),
    [],
  );

  return {
    botInfo,
    updateBotInfoConfig,
  };
}

export default useBotInfo;
